import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faFilePdf,
  faFileWord,
  faFilePowerpoint,
  faFileCsv,
  faFileImage,
  faFileArchive,
  faFile
} from '@fortawesome/free-solid-svg-icons'

function getFileIcon(filename) {
  let icon
  let name = filename.toString().split('.')

  switch(name[name.length - 1]) {
  case 'pdf':
    icon = faFilePdf
    break
  case 'docx' || 'doc':
    icon = faFileWord
    break
  case 'pptx':
    icon = faFilePowerpoint
    break
  case 'csv':
    icon = faFileCsv
    break
  case 'png':
    icon = faFileImage
    break
  case 'jpg' || 'jpeg':
    icon = faFileImage
    break
  case 'zip':
    icon = faFileArchive
    break
  default:
    icon = faFile
  }

  return (
    <FontAwesomeIcon icon={icon} fixedWidth />
  )
}

export {
  getFileIcon
}